export class SmartphotoImageAlertAdapter {
    smartphoto;
    constructor(smartphoto) {
        this.smartphoto = smartphoto;
    }
    transform(imageUUID) {
        const alertsMap = {
            screenDetection: Boolean(this.smartphoto.fraudSummary?.screenDetection?.detail?.find((image) => image.fraud && image.image_uuid === imageUUID)),
            vehicleDetection: Boolean(this.smartphoto.qualitySummary?.vehicleDetection.detail?.find((image) => image.issue && image.image_uuid === imageUUID)),
            orientationDetection: Boolean(this.smartphoto.qualitySummary?.orientationDetection.detail?.find((image) => image.issue && image.image_uuid === imageUUID)),
            qualityDetection: Boolean(this.smartphoto.qualitySummary?.qualityDetection.detail?.find((image) => image.issue && image.image_uuid === imageUUID))
        };
        return Object.keys(alertsMap).filter((alertType) => alertsMap[alertType]);
    }
}
